<template>
  <router-view />
  <section style="position: absolute">
    <div id="modals" style="position: relative; z-index: 1" />
    <Dialog v-for="dialog in dialogs" :key="dialog.id" :dialog="dialog" />
    <div id="context-menu" style="position: relative; z-index: 2" />
    <Tooltip style="z-index: 3" />
    <PendingBlock v-if="pending" style="position: absolute; z-index: 4" />
    <ReportDelegator v-show="false" />
  </section>
</template>

<script>
import Dialog from 'eop-shared-components/plugins/dialog/Dialog'
import PendingBlock from 'eop-shared-components/commons/PendingBlock'
import ReportDelegator from 'eop-shared-components/plugins/report/ReportDelegator'
import Tooltip from 'eop-shared-components/plugins/v-tooltip/Tooltip'
import { mapGetters } from 'vuex'
import { buildFcmTokenHeader } from '@/constants'
import ENV from '@/constants/env'

export default {
  name: 'App',
  components: { Dialog, Tooltip, PendingBlock, ReportDelegator },
  computed: {
    ...mapGetters({ dialogs: 'dialog/getDialogList', pending: 'system/isPending', userAccount: 'accounts/getUserAccount' }),
  },
  mounted() {
    const checkToken = (interval) => this.$api.checkToken(interval, { headers: buildFcmTokenHeader() })
    checkToken()
    window.addEventListener('FcmTokenStored', () => checkToken())
    window.addEventListener('FcmMessageReceived', ({ detail }) => {
      checkToken()
      this.handleFcmMessage(detail)
    })
    const checkInterval = 600
    this.tokenChecker = setInterval(async () => {
      await this.$store.dispatch('accounts/updateUserAccount')
      await checkToken(checkInterval)
    }, checkInterval * 1000)
    if (ENV !== 'prod') {
      this.keyEventListener = async (e) => {
        if (e.ctrlKey && e.altKey && e.key === 'c' && this.userAccount) {
          this.$dialog.confirm('[DEV] COPY CURRENT USER ACCOUNT', () => {
            navigator.clipboard.writeText(JSON.stringify(this.userAccount))
          })
        }
      }
      window.addEventListener('keyup', this.keyEventListener)
    }
    window.addEventListener('beforeunload', () => {
      clearInterval(this.tokenChecker)
      window.removeEventListener('keyup', this.keyEventListener)
    })
  },
  methods: {
    handleFcmMessage({ username, category, json: { level, message, event } }) {
      const isCurrentUser = username === this.userAccount?.username
      switch (category) {
        case 'SimpleMessage':
          if (isCurrentUser) {
            switch (level) {
              case 'Information':
                return
              case 'Warning':
                return
              case 'Critical':
                this.$dialog.notify(message, { title: '알림' })
                return
            }
          }
          return
        case 'EventMessage':
          if (isCurrentUser) {
            const { eventCategory, entityType, entityId } = event || {}
            window.dispatchEvent(new CustomEvent(eventCategory, { detail: { message, entityType, entityId } }))
          }
          return
      }
    },
  },
}
</script>

<style>
@font-face {
  font-family: 'Noto Sans CJK KR';
  src: url('../assets/lib/NotoSansKR/NotoSansKR-Light.woff2') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'Noto Sans CJK KR';
  src: url('../assets/lib/NotoSansKR/NotoSansKR-Medium.woff2') format('truetype');
  font-weight: bold;
}
</style>

<style lang="scss">
@import 'eop-ui-core/styles/variables/colors';
@import 'eop-ui-core/styles/variables/size-mobile';

@import 'eop-ui-core/styles/modules/elements';
@import 'eop-ui-core/styles/modules/inputs';
@import 'eop-ui-core/styles/modules/button';
@import 'eop-ui-core/styles/modules/scrollbar';
@import 'eop-ui-core/styles/modules/common-classes';

body {
  transition: background-color 0.2s;
}

button,
.button {
  font-weight: bold;
  padding: calc(var(--margin) / 2) var(--margin);
}
.card {
  box-shadow: 0 0 16px -8px var(--color-default);
}
.fa-spin-faster {
  animation: fa-spin 0.5s linear infinite;
  opacity: 0.5;
}
.modal > * {
  width: 100%;
}
.full-width {
  max-width: 800px;
}
.modal-header-right button.icon.square {
  position: absolute;
  right: 0;
}
</style>
